import MultiEmailInput from "@components/common/inputs/MultiEmailInput";

import { alert } from "../../common/Alert";

const AddUsers = ({
  newUserEmails,
  setNewUserEmails,
  team = { uuid: "", users: [] },
}) => {
  const teamUsersArray = team?.users?.map((user) => user.email) || [];
  const invitedMembers =
    team?.teamInvites
      ?.filter((invite) => invite.status === "pending")
      ?.map((invite) => invite.inviteeEmail) || [];

  const customValidation = (email) => {
    // Check if already invited
    if (invitedMembers?.includes(email)) {
      alert("warning", `${email} is already invited to this team.`);
      return false;
    }

    // Check domain restriction
    if (team?.emailDomain) {
      const domain = email?.split("@")[1];
      if (domain?.toLowerCase() !== team.emailDomain.toLowerCase()) {
        alert(
          "error",
          `Your organization only allows users to be added with a specific email domain. The user's email must have an @${team.emailDomain} domain.`,
        );
        return false;
      }
    }

    return true;
  };

  return (
    <div className="mt-2">
      <MultiEmailInput
        emails={newUserEmails}
        setEmails={setNewUserEmails}
        placeholder="Add user"
        infoText="Type in the email of each new team member."
        customValidation={customValidation}
        existingEmails={teamUsersArray}
        dataTestId="add-user-textarea"
      />
    </div>
  );
};

export default AddUsers;
